/**
 * @copyright KARD.
 */

import React from 'react'

// import { navigate } from "@reach/router"

/**
 */
class P404 extends React.PureComponent
{
    render()
    {
        return (
            <div className="main-wrapper error-wrapper">
                <div className="error-box">
                    <h1>404</h1>
                    <h3><i className="fa fa-warning" /> Oops! Page not found!</h3>
                    <p>The page you requested was not found.</p>
                    <a href="/dashboard" className="btn btn-primary go-home">Go to Home</a>
                </div>
            </div>
        )
    }
}   // P404

/**
 */
export default P404

